// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Link$LiveRoom from "../../Link.bs.js";
import * as I18next$LiveRoom from "../../bindings/I18next.bs.js";
import * as CommonStyles$LiveRoom from "../../styles/CommonStyles.bs.js";
import * as SterlingModal$LiveRoom from "../../bindings/SterlingModal.bs.js";
import * as SterlingTokens$LiveRoom from "../../bindings/SterlingTokens.bs.js";
import * as Button from "@sothebys/sterling/button";
import * as SterlingTypography$LiveRoom from "../../bindings/SterlingTypography.bs.js";

function AuctionClosedModal(props) {
  var closeModal = props.closeModal;
  var match = I18next$LiveRoom.useTranslation(undefined);
  var t = match.t;
  return React.createElement(SterlingModal$LiveRoom.Modal.make, {
              children: null,
              className: Curry._1(Css.style, {
                    hd: CommonStyles$LiveRoom.mediaV2(/* DesktopAndTabletLandscape */4, {
                          hd: Css.important(Css.maxWidth(Css.px(500))),
                          tl: /* [] */0
                        }),
                    tl: {
                      hd: Css.width(Css.pct(100)),
                      tl: {
                        hd: Css.selector("& > div", {
                              hd: CommonStyles$LiveRoom.mediaV2(/* TabletPortraitAndMobile */2, {
                                    hd: Css.important(Css.paddingLeft(Css.px(24))),
                                    tl: {
                                      hd: Css.important(Css.paddingRight(Css.px(24))),
                                      tl: /* [] */0
                                    }
                                  }),
                              tl: /* [] */0
                            }),
                        tl: /* [] */0
                      }
                    }
                  }),
              onClose: (function (param) {
                  Curry._1(closeModal, undefined);
                }),
              isOpen: true,
              headerTitle: Curry._1(t, "AuctionRoomProp_thisAuctionIsNowClosed")
            }, React.createElement(SterlingModal$LiveRoom.Content.make, {
                  children: React.createElement(SterlingTypography$LiveRoom.Paragraph16Regular.make, {
                        className: Curry._1(Css.style, {
                              hd: Css.textAlign(Css.center),
                              tl: {
                                hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryNavy100_nohashtag)),
                                tl: /* [] */0
                              }
                            }),
                        children: Curry._1(t, "AuctionClosed_thankYouForParticipating")
                      }),
                  className: Curry._1(Css.style, {
                        hd: Css.marginBottom(Css.px(20)),
                        tl: /* [] */0
                      })
                }), React.createElement(SterlingModal$LiveRoom.Footer.make, {
                  children: React.createElement("div", {
                        className: Curry._1(Css.style, {
                              hd: Css.width(Css.pct(100.0)),
                              tl: /* [] */0
                            })
                      }, React.createElement(Link$LiveRoom.AuctionDetailPage.make, {
                            auctionUrl: props.auctionUrl,
                            children: React.createElement(Button.Button, {
                                  onClick: (function (param) {
                                      Curry._1(closeModal, undefined);
                                    }),
                                  children: Curry._1(t, "AuctionClosed_viewResults")
                                }),
                            className: Curry._1(Css.style, {
                                  hd: Css.important(Css.textDecorationLine("none")),
                                  tl: /* [] */0
                                })
                          })),
                  className: Curry._1(Css.style, {
                        hd: Css.display("flex"),
                        tl: {
                          hd: Css.important(Css.justifyContent("center")),
                          tl: /* [] */0
                        }
                      })
                }));
}

var make = AuctionClosedModal;

export {
  make ,
}
/* Css Not a pure module */
